import { graphql, StaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import './partnerLogos.scss'

const PartnersLogos = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          images: allFile(
            filter: {
              sourceInstanceName: { eq: "images" }
              absolutePath: { regex: "/home-partners/" }
            }
          ) {
            edges {
              node {
                relativePath
                name
                childImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      `}
      render={({ images }) => {
        return images.edges.map(({ node }) => {
          const alt = node.name?.split('-')[0]

          return (
            <GatsbyImage
              className="partner-logo"
              key={node.name}
              image={node.childImageSharp.gatsbyImageData}
              alt={alt}
              imgStyle={{
                objectFit: 'contain',
                width: '105px',
                height: '70px',
              }}
            />
          )
        })
      }}
    />
  )
}

export default PartnersLogos
